/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateExportToSymphonyDataDto
 */
export interface CreateExportToSymphonyDataDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateExportToSymphonyDataDto
     */
    selectedInvoices?: Array<string>;
}

/**
 * Check if a given object implements the CreateExportToSymphonyDataDto interface.
 */
export function instanceOfCreateExportToSymphonyDataDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateExportToSymphonyDataDtoFromJSON(json: any): CreateExportToSymphonyDataDto {
    return CreateExportToSymphonyDataDtoFromJSONTyped(json, false);
}

export function CreateExportToSymphonyDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateExportToSymphonyDataDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'selectedInvoices': !exists(json, 'selectedInvoices') ? undefined : json['selectedInvoices'],
    };
}

export function CreateExportToSymphonyDataDtoToJSON(value?: CreateExportToSymphonyDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'selectedInvoices': value.selectedInvoices,
    };
}

